import { FaCheckCircle, FaClipboardCheck, FaFileInvoiceDollar, FaShieldAlt, FaStethoscope, FaUserCheck } from "react-icons/fa";

export const metrics = [
    {
        icon: <FaUserCheck />,
        value: "20+",
        label: "Years of Combined Industry Experience",
        style: "metricPrimary",
    },
    {
        icon: <FaFileInvoiceDollar />,
        value: "03%",
        label: "AR Rejection Rate",
        style: "metricAccent",
    },
    {
        icon: <FaClipboardCheck />,
        value: "98%",
        label: "Accuracy Rate",
        style: "metricLight",
    },
    {
        icon: <FaShieldAlt />,
        value: "100%",
        label: "HIPAA Compliance",
        style: "metricDark",
    },
];

export const assurances = [
    {
        icon: <FaCheckCircle />,
        label: "Accurate Procedure Review",
    },
    {
        icon: <FaStethoscope />,
        label: "Reliable Diagnosis Support",
    },
    {
        icon: <FaFileInvoiceDollar />,
        label: "Timely Paymentss",
    },
];